import React from "react";
import Header from "../../component/bak/Header";
import MenuPage from "../../component/bak/MenuPage";

const MemberList = () => {
  return (
    <React.Fragment>
      <div>맴버 리스트 화면입니다</div>
    </React.Fragment>
  );
};

export default MemberList;
